/**
 * 期間タイプ
 */
export const PeriodType = {
  SEVEN_DAYS: '7days',
  THIRTY_DAYS: '30days',
  NINETY_DAYS: '90days',
} as const

export type PeriodTypeValue = (typeof PeriodType)[keyof typeof PeriodType]

export const PeriodTypeValues = [
  { code: PeriodType.SEVEN_DAYS, value: '過去7日間', days: 7 },
  { code: PeriodType.THIRTY_DAYS, value: '過去30日間', days: 30 },
  { code: PeriodType.NINETY_DAYS, value: '過去90日間', days: 90 },
]

export const PeriodTypeLabel = {
  [PeriodType.SEVEN_DAYS]: '過去7日間',
  [PeriodType.THIRTY_DAYS]: '過去30日間',
  [PeriodType.NINETY_DAYS]: '過去90日間',
}

/**
 * 期間タイプから日数を取得する
 * @param period 期間タイプ
 * @returns 日数（例：7）
 */
export const getPeriodDays = (period: PeriodTypeValue): number => {
  const found = PeriodTypeValues.find((p) => p.code === period)
  if (found === undefined) {
    throw new Error(`Period type ${period} not found`)
  }
  return found.days
}
